<template>
  <div class="TabsChange">
    <el-tabs
        v-model="temp"
        :type="cardType"
        :stretch="stretchType"
        @tab-click="handleClick"
    >
      <el-tab-pane
          :key="index"
          v-for="(item, index) in defaultList"
          :label="item"
          :name="String(index)"
      >
        <slot :name="index | changeNum"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "TabsChange",
  filters: {
    changeNum(val) {
      return String(val);
    },
  },
  props: {
    activeName: {
      type: String,
      default: "0",
    },
    tabList: {
      type: Array,
      default() {
        return [];
      },
    },
    cardType: {
      type: String,
      default: "card",
    },
    stretchType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      //用临时变量代替，防止出现子组件修改父组件数据报错
      temp: "0",
      defaultList: [],
    };
  },
  methods: {
    //点击方法拉出去，用的时候更灵活
    handleClick(tab) {
      // 选中item
      this.$emit("selectInfo", tab);
    },
  },
  computed: {},
  watch: {
    activeName: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.temp = this.activeName;
        }
      },
      deep: true,
      immediate: true,
    },
    tabList: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.defaultList = this.tabList;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.TabsChange {
}
</style>
